<template>
  <div class="token-page">
    <h2>API: {{ token }}</h2>
    <!-- <p>当前 API: {{ token }}</p> -->

    <!-- Tab 选项卡 -->
    <el-tabs v-model="activeTab" type="border-card" class="tab-container" @tab-click="tabClick">
      <!-- 资产余额 Tab -->
      <el-tab-pane label="资产余额" name="balance">
        <div class="tab-content">
          <!-- 查询条件 -->
          <!-- <div class="search-form">
            <el-form :inline="true" :model="balanceForm" class="demo-form-inline">
              <el-form-item label="币种">
                <el-input v-model="balanceForm.currency" placeholder="请输入币种"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="searchBalance">查询</el-button>
                <el-button @click="resetBalanceForm">重置</el-button>
              </el-form-item>
            </el-form>
          </div> -->
          <!-- 表格 -->
          <el-table :data="balanceData" border>
            <el-table-column prop="currency" label="币种"></el-table-column>
            <el-table-column prop="balance" label="数量"></el-table-column>
            <el-table-column prop="available" label="可用"></el-table-column>
            <el-table-column prop="holds" label="冻结"></el-table-column>
          </el-table>
          <!-- 分页 -->
          <el-pagination @size-change="handleBalanceSizeChange" @current-change="handleBalanceCurrentChange"
            :current-page="balancePage" :page-sizes="[5, 10, 20, 50]" :page-size="balancePageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="balanceTotal" class="pagination"></el-pagination>
        </div>
      </el-tab-pane>

      <!-- 资产划转 Tab -->
      <el-tab-pane label="资产划转" name="transfer" v-if="false">
        <div class="tab-content">
          <!-- 查询条件 -->
          <div class="search-form">
            <el-form :inline="true" :model="transferForm" class="demo-form-inline">
              <el-form-item label="币种">
                <el-input v-model="transferForm.currency" placeholder="请输入币种"></el-input>
              </el-form-item>
              <el-form-item label="方向">
                <el-select v-model="transferForm.direction" placeholder="请选择方向">
                  <el-option label="全部" value=""></el-option>
                  <el-option label="现货→合约" value="现货→合约"></el-option>
                  <el-option label="合约→现货" value="合约→现货"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="searchTransfer">查询</el-button>
                <el-button @click="resetTransferForm">重置</el-button>
              </el-form-item>
            </el-form>
          </div>
          <!-- 表格 -->
          <el-table :data="transferData" border>
            <el-table-column prop="currency" label="币种"></el-table-column>
            <el-table-column prop="amount" label="数量"></el-table-column>
            <el-table-column prop="direction" label="方向"></el-table-column>
            <el-table-column prop="confirm" label="确认">
              <template slot-scope="scope">
                <el-button type="primary" size="small" @click="handleTransfer(scope.row)">确认</el-button>
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <el-pagination @size-change="handleTransferSizeChange" @current-change="handleTransferCurrentChange"
            :current-page="transferPage" :page-sizes="[5, 10, 20, 50]" :page-size="transferPageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="transferTotal" class="pagination"></el-pagination>
        </div>
      </el-tab-pane>

      <!-- 成交数据 Tab -->
      <el-tab-pane label="历史成交" name="trade">
        <div class="tab-content">
          <!-- 查询条件 -->
          <div class="search-form" style="display: flex; flex-wrap: wrap; align-items: center;">
            <el-form :inline="true" :model="tradeForm" class="demo-form-inline" style="display: flex; flex-wrap: wrap; align-items: center;">
              <!-- <el-form-item label="成交编号" style="margin-right: 10px;">
                <el-input v-model="tradeForm.id" placeholder="请输入编号" style="width: 120px;"></el-input>
              </el-form-item> -->
              <el-form-item label="交易对" style="margin-right: 10px;">
                <el-select v-model="tradeForm.pair" placeholder="请选择" style="width: 130px;">
                  <el-option label="全部" value=""></el-option>
                  <el-option v-for="item in apiChildrenOptions" :key="item.id" :label="item.label" :value="item.label"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="方向" style="margin-right: 10px;">
                <el-select v-model="tradeForm.direction" placeholder="请选择" style="width: 100px;">
                  <el-option label="全部" value=""></el-option>
                  <el-option label="买入" value="buy"></el-option>
                  <el-option label="卖出" value="sell"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="时间范围" style="margin-right: 10px;">
                <el-date-picker
                  v-model="tradeForm.timeRange"
                  type="datetimerange"
                  range-separator="-"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 380px;"
                  :picker-options="{
                    selectableRange: '00:00:00 - 23:59:59'
                  }"
                ></el-date-picker>
              </el-form-item>
              <el-form-item style="margin-right: 0;">
                <el-button type="primary" @click="searchTrade" style="padding: 9px 15px;">查询</el-button>
                <el-button @click="resetTradeForm" style="padding: 9px 15px;">重置</el-button>
                <el-button @click="exportTrade()" style="padding: 9px 15px;">导出</el-button>
              </el-form-item>
            </el-form>
          </div>
          <!-- 总计表格 -->
          <el-table :data="tradeTotalData" border>
            <el-table-column prop="amount" label="总成交数量"></el-table-column>
            <el-table-column prop="price" label="平均成交价格"></el-table-column>
            <el-table-column prop="total" label="总成交金额"></el-table-column>
            <el-table-column prop="fee" label="总手续费"></el-table-column>
          </el-table>
          <!-- 表格 -->
          <el-table :data="tradeData" border>
            <el-table-column prop="id" label="成交编号"></el-table-column>
            <el-table-column prop="time" label="成交时间"></el-table-column>
            <el-table-column prop="pair" label="交易对" width="120"></el-table-column>
            <el-table-column prop="direction" label="方向" width="80"></el-table-column>
            <el-table-column prop="amount" label="成交数量"></el-table-column>
            <el-table-column prop="price" label="成交价格"></el-table-column>
            <el-table-column prop="total" label="成交金额"></el-table-column>
            <el-table-column prop="fee" label="手续费"></el-table-column>
            <el-table-column prop="feeCurrency" label="计费币种" width="80"></el-table-column>
            <!-- <el-table-column prop="type" label="类型"></el-table-column> -->
          </el-table>
          <!-- 分页 -->
          <el-pagination @size-change="handleTradeSizeChange" @current-change="handleTradeCurrentChange"
            :current-page="tradePage" :page-sizes="[5, 10, 20, 50]" :page-size="tradePageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="tradeTotal" class="pagination"></el-pagination>
        </div>
      </el-tab-pane>

      <!-- 委托数据 Tab -->
      <el-tab-pane label="历史委托" name="order">
        <div class="tab-content">
          <!-- 查询条件 -->
          <div class="search-form" style="display: flex; flex-wrap: wrap; align-items: center;">
            <el-form :inline="true" :model="orderForm" class="demo-form-inline" style="display: flex; flex-wrap: wrap; align-items: center;">
              <!-- <el-form-item label="成交编号" style="margin-right: 10px;">
                <el-input v-model="orderForm.id" placeholder="请输入编号" style="width: 120px;"></el-input>
              </el-form-item> -->
              <el-form-item label="交易对" style="margin-right: 10px;">
                <el-select v-model="orderForm.pair" placeholder="请选择" style="width: 130px;">
                  <el-option label="全部" value=""></el-option>
                  <el-option v-for="item in apiChildrenOptions" :key="item.id" :label="item.label" :value="item.label"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="方向" style="margin-right: 10px;">
                <el-select v-model="orderForm.direction" placeholder="请选择" style="width: 100px;">
                  <el-option label="全部" value=""></el-option>
                  <el-option label="买入" value="buy"></el-option>
                  <el-option label="卖出" value="sell"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="时间范围" style="margin-right: 10px;">
                <el-date-picker
                  v-model="orderForm.timeRange"
                  type="datetimerange"
                  range-separator="-"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 380px;"
                  :picker-options="{
                    selectableRange: '00:00:00 - 23:59:59'
                  }"
                ></el-date-picker>
              </el-form-item>
              <el-form-item style="margin-right: 0;">
                <el-button type="primary" @click="searchOrder" style="padding: 9px 15px;">查询</el-button>
                <el-button @click="resetOrderForm" style="padding: 9px 15px;">重置</el-button>
                <el-button @click="exportOrder()" style="padding: 9px 15px;">导出</el-button>
              </el-form-item>
            </el-form>
          </div>
          <!-- 总计表格 -->
           <el-table :data="orderTotalData" border>
            <el-table-column prop="amount" label="总委托数量"></el-table-column>
            <el-table-column prop="price" label="平均委托价格"></el-table-column>
            <el-table-column prop="total" label="总委托金额"></el-table-column>
            <el-table-column prop="dealSize" label="总成交数量"></el-table-column>
          </el-table>
          <!-- 表格 -->
          <el-table :data="orderTableData" border>
            <el-table-column prop="id" label="委托编号"></el-table-column>
            <el-table-column prop="time" label="委托时间"></el-table-column>
            <el-table-column prop="pair" label="交易对" width="120"></el-table-column>
            <el-table-column prop="direction" label="方向" width="80"></el-table-column>
            <el-table-column prop="opType" label="状态"></el-table-column>
            <el-table-column prop="amount" label="委托数量"></el-table-column>
            <el-table-column prop="price" label="委托价格"></el-table-column>
            <el-table-column prop="total" label="委托金额"></el-table-column>
            <el-table-column prop="dealSize" label="成交数量"></el-table-column>
            <el-table-column prop="hidden" label="隐藏" width="80"></el-table-column>
            <el-table-column prop="visibleSize" label="冰山单" width="80"></el-table-column>
          </el-table>
          <!-- 分页 -->
          <el-pagination @size-change="handleOrderSizeChange" @current-change="handleOrderCurrentChange"
            :current-page="orderPage" :page-sizes="[5, 10, 20, 50]" :page-size="orderPageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="orderTotal" class="pagination"></el-pagination>
        </div>
      </el-tab-pane>

      <!-- 持仓 Tab -->
      <el-tab-pane v-if="api && api.apiType == 2" label="持仓" name="position">
        <div class="tab-content">
          <!-- 查询条件 -->
          <div class="search-form">
            <el-form :inline="true" :model="positionForm" class="demo-form-inline">
              <el-form-item label="交易对">
                <el-input v-model="positionForm.pair" placeholder="请输入交易对"></el-input>
              </el-form-item>
              <el-form-item label="持仓方向">
                <el-select v-model="positionForm.direction" placeholder="请选择持仓方向">
                  <el-option label="全部" value=""></el-option>
                  <el-option label="做多" value="long"></el-option>
                  <el-option label="做空" value="short"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="searchPosition">查询</el-button>
                <el-button @click="resetPositionForm">重置</el-button>
              </el-form-item>
            </el-form>
          </div>
          <!-- 表格 -->
          <el-table :data="positionData" border>
            <el-table-column prop="pair" label="交易对"></el-table-column>
            <el-table-column prop="direction" label="持仓方向"></el-table-column>
            <el-table-column prop="holdPrice" label="持仓均价"></el-table-column>
            <el-table-column prop="holdSz" label="持仓量"></el-table-column>
            <el-table-column prop="openBal" label="开仓保证金"></el-table-column>
            <el-table-column prop="liqPrice" label="强平价格"></el-table-column>
            <el-table-column prop="mgnMode" label="保证金模式"></el-table-column>
            <el-table-column prop="leverage" label="杠杆倍率"></el-table-column>
          </el-table>
          <!-- 分页 -->
          <!-- <el-pagination @size-change="handlePositionSizeChange" @current-change="handlePositionCurrentChange"
            :current-page="positionCurrentPage" :page-sizes="[5, 10, 20, 50]" :page-size="positionPageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="positionTotal" class="pagination"></el-pagination> -->
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import API from "./api";
import exAccounts from "@/proto/exAccounts_pb";
import exQryOrders from "@/proto/exQryOrders_pb";
import exQryFills from "@/proto/exQryFills_pb";
import exQryHolds from "@/proto/exQryHolds_pb";
import utils from "../lib/utils";
import Decimal from "decimal.js";
import * as XLSX from "xlsx";
import FileSaver from "file-saver";
let mathjs = require("mathjs");
export default {
  name: "TokenPage",
  data() {
    return {
      token: "",
      exchange: "",
      api: {},
      activeTab: "balance",
      // 查询表单
      balanceForm: {
        currency: ""
      },
      transferForm: {
        currency: "",
        direction: ""
      },
      tradeForm: {
        id: "",
        pair: "",
        direction: "",
        type: "",
        timeRange: []
      },
      orderForm: {
        id: "",
        pair: "",
        direction: "",
        type: "",
        timeRange: []
      },
      // 资产余额数据
      balanceOriginData: [],
      balanceData: [],
      balancePage: 1,
      balancePageSize: 5,
      balanceTotal: 0,
      // 资产划转数据
      transferOriginData: [],
      transferData: [],
      transferPage: 1,
      transferPageSize: 5,
      transferTotal: 0,
      // 成交数据
      tradeOriginData: [],
      tradeData: [],
      tradeTotalData: [],
      tradePage: 1,
      tradePageSize: 5,
      tradeTotal: 0,
      // 委托数据
      orderOriginData: [],
      orderTableData: [],
      orderTotalData: [],
      orderPage: 1,
      orderPageSize: 5,
      orderTotal: 0,
      // 持仓表单
      positionForm: {
        pair: "",
        direction: ""
      },
      // 持仓数据
      positionOriginData: [],
      positionData: [],
      positionCurrentPage: 1,
      positionPageSize: 5,
      positionTotal: 0
    };
  },
  created() {
    let nowDate = new Date();
    let endDate = utils.dateFormat(nowDate.getTime());
    let startDate = utils.dateFormat(nowDate.getTime() - 1 * 24 * 60 * 60 * 1000);
    this.tradeForm.timeRange = [startDate, endDate];
    this.orderForm.timeRange = [startDate, endDate];
    this.token = this.$route.params.token || "";
    this.exchange = this.$route.params.exchange || "";
    // this.parseApiJson();
    try {
      const apiJson = this.$route.query.apiJson || "";
      if (apiJson) {
        this.api = JSON.parse(decodeURIComponent(apiJson));
      }
    } catch (e) {
      console.error('解析失败:', e);
      this.api = {};
    }
    this.initTables();
  },
  computed: {
    apiChildrenOptions() {
      return this.api.children || [];
    }
  },
  watch: {
    $route(to) {
      this.token = to.params.token || "";
      this.exchange = to.params.exchange || "";
      this.parseApiJson();
      this.initTables();
    }
  },
  methods: {
    parseApiJson() {
      try {
        const apiJson = this.$route.params.apiJson || "";
        if (apiJson) {
          this.api = JSON.parse(decodeURIComponent(apiJson));
          console.log("apiObj==", this.api)
        } else {
          this.api = {};
        }
      } catch (e) {
        console.error('解析 apiJson 失败:', e);
        this.api = {};
      }
    },

    // 选中选项卡
    tabClick(tab, event) {
      if (tab.name === "balance") {
        this.searchBalance();
      } else if (tab.name === "trade") {
        this.searchTrade();
      } else if (tab.name === "order") {
        this.searchOrder();
      } else if (tab.name === "position") {
        this.searchPosition();
      }
    },

    initTables() {
      this.balanceTotal = this.balanceOriginData.length;
      this.transferTotal = this.transferOriginData.length;
      this.tradeTotal = this.tradeOriginData.length;
      this.orderTotal = this.orderOriginData.length;
      this.positionTotal = this.positionOriginData.length;
      this.getBalanceData();
      // this.getTransferData();
      // this.getTradeData();
      // this.getOrderData();
      // this.getPositionData();
    },
    // 资产余额
    // getBalanceData() {
    //   let data = [...this.balanceOriginData];
    //   if (this.balanceForm.currency) {
    //     data = data.filter(item => item.currency.toLowerCase().includes(this.balanceForm.currency.toLowerCase()));
    //   }
    //   this.balanceTotal = data.length;
    //   const start = (this.balancePage - 1) * this.balancePageSize;
    //   const end = start + this.balancePageSize;
    //   this.balanceData = data.slice(start, end);
    // },
    getBalanceData() {
      // console.log('getAccounts----------')
      var data = {
        uid: localStorage.getItem("userName"),
        apiId: this.token,
        currency: "",
        type: "",
        exchange: Number(this.exchange)
      };
      API.getAccounts(data).then((res) => {
        if (res.data.errcode === 0) {
          var buffer = res.data.buffer;
          var message = exAccounts.ExAccounts.deserializeBinary(buffer);
          var accountTableArray = [];

          message.getDataList().forEach((element) => {
            var data = {
              currency: element.getCurrency(),
              type: element.getType(),
              balance: element.getBalance(),
              available: element.getAvailable(),
              holds: element.getHolds()
            };
            accountTableArray.push(data);
          });
          // 去重
          var transferTableArray = [];
          var obj = {};
          for (var i = 0; i < accountTableArray.length; i++) {
            if (!obj[accountTableArray[i].currency]) {
              transferTableArray.push(accountTableArray[i]);
              obj[accountTableArray[i].currency] = true;
            }
          }
          // this.accountTableData = accountTableArray;
          this.balanceTotal = accountTableArray.length;
          const start = (this.balancePage - 1) * this.balancePageSize;
          const end = start + this.balancePageSize;
          this.balanceData = accountTableArray.slice(start, end);
        } else {
          this.$message.error(res.data.errcode + ":" + res.data.errmsg);
          if (res.data.errcode === 3005) {
            // 无效的登录凭证
            this.$router.push("/login");
          }
        }
      });
    },
    searchBalance() {
      this.balancePage = 1;
      this.getBalanceData();
    },
    resetBalanceForm() {
      this.balanceForm = { currency: "" };
      this.balancePage = 1;
      this.getBalanceData();
    },
    // 资产划转
    getTransferData() {
      let data = [...this.transferOriginData];
      if (this.transferForm.currency) {
        data = data.filter(item => item.currency.toLowerCase().includes(this.transferForm.currency.toLowerCase()));
      }
      if (this.transferForm.direction) {
        data = data.filter(item => item.direction === this.transferForm.direction);
      }
      this.transferTotal = data.length;
      const start = (this.transferPage - 1) * this.transferPageSize;
      const end = start + this.transferPageSize;
      this.transferData = data.slice(start, end);
    },
    searchTransfer() {
      this.transferPage = 1;
      this.getTransferData();
    },
    resetTransferForm() {
      this.transferForm = { currency: "", direction: "" };
      this.transferPage = 1;
      this.getTransferData();
    },
    // 成交数据
    async getTradeData() {
      let pageSizee = 1000;

      let startAt = new Date(this.tradeForm.timeRange[0]).getTime();
      let endAt = new Date(this.tradeForm.timeRange[1]).getTime();

      var fillsDataArray = [];
      let tradeSymbol = [];
      if (this.tradeForm.pair === "") {
        for (let e of this.api.children) {
          var ddd = {
            symbol: e.symbol
          };
          tradeSymbol.push(ddd);
        }
      } else {
        var dddd = {
          symbol: this.tradeForm.pair
        };
        tradeSymbol.push(dddd);
      }

      // console.log(this.tradeForm.pair)
      // 如果交易对选了全部，有多个交易对就查多次
      for (let e of tradeSymbol) {
        var data = {
          uid: localStorage.getItem("userName"),
          apiId: this.token,
          exchange: Number(this.exchange),
          symbol: e.symbol,
          side: "",
          currentPage: this.tradePage.toString(),
          pageSize: pageSizee + "",
          startAt: startAt,
          endAt: endAt,
          tradeType: "TRADE"
        };
        let res = await API.getFills(data);
        if (res.data.errcode === 0) {
          var buffer = res.data.buffer;
          var message = exQryFills.ExQryFills.deserializeBinary(buffer);
          // console.log(message);
          var fillsData = message.getData();
          fillsData.getItemsList().forEach((element) => {
            var data = {
              pair: element.getSymbol(), // 交易对
              id: element.getTradeid(), // 交易id
              // tradeIntId: element.getTradeintid(),
              // id: element.getOrderid(), // 订单id
              direction: element.getSide().toLowerCase(), // buy/sell
              price: element.getPrice(), // 订单价格
              amount: element.getSize(), // 下单数量
              total: element.getFunds(), // 下单金额
              fee: element.getFee(), // 手续费
              // feeRate: element.getFeerate(), // 手续费率
              feeCurrency: element.getFeecurrency(), // 计手续费币种
              type: element.getType().toLowerCase(), // limit 或 market
              time:
                element.getCreatedat() === 0
                  ? ""
                  : utils.dateFormat(element.getCreatedat()), // 创建时间
              // tradeType: element.getTradetype(), // 交易类型: TRADE, MARGIN_TRADE
              // ordercreateAt: ""
            };

            // 处理成交金额
            let fund = new Decimal(element.getPrice()).mul(new Decimal(element.getSize()));
            data.total = fund.toNumber();
            // console.log(data);
            fillsDataArray.push(data);
          });
        } else {
          this.$message.error(res.data.errcode + ":" + res.data.errmsg);
          if (res.data.errcode === 3005) {
            // 无效的登录凭证
            this.$router.push("/login");
          }
          if (res.data.errcode === 4004) {
            this.tradePage = this.tradePage - 1;
          }
        }
      }
      // 处理数据
      // console.log(fillsDataArray);
      // 过滤买入卖出
      if (this.tradeForm.direction) {
        fillsDataArray = fillsDataArray.filter((r) => {
          let row = r.direction;
          return row.includes(this.tradeForm.direction);
        });
      }

      // console.log(fillsDataArray);
      this.tradeOriginData = fillsDataArray;

      this.tradeData = [];
      var fillLen = fillsDataArray.length;
      this.tradeTotal = fillLen;
      // console.log(this.tradeTotal)
      // this.tableData = fillsDataArray;
      let pageSize = this.tradePageSize;
      if (fillLen > pageSize) {
        let start = (this.tradePage.toString() - 1) * pageSize;
        let end = this.tradePage.toString() * pageSize;
        this.tradeData = fillsDataArray.slice(start, end);
      } else {
        this.tradeData = fillsDataArray;
      }
      this.getTradeDataTotal();
    },
    // 计算总计
    getTradeDataTotal() {
      this.tradeTotalData = [];
      let totalAmount = new Decimal(0);
      let avgPrice = new Decimal(0);
      let totalTotal = new Decimal(0);
      let totalFee = new Decimal(0);
      let tradeLength = new Decimal(this.tradeOriginData.length);
      for (let item of this.tradeOriginData) {
        totalAmount = totalAmount.add(new Decimal(item.amount));
        avgPrice = avgPrice.add(new Decimal(item.price));
        totalTotal = totalTotal.add(new Decimal(item.total));
        totalFee = totalFee.add(new Decimal(item.fee));
      }
      let data = {
        amount: totalAmount.toNumber(),
        price: avgPrice.div(tradeLength).toNumber().toFixed(6),
        total: totalTotal.toNumber(),
        fee: totalFee.toNumber()
      };
      this.tradeTotalData.push(data);
    },
    searchTrade() {
      this.tradePage = 1;
      this.getTradeData();
    },
    resetTradeForm() {
      this.tradeForm = { id: "", pair: "", direction: "", type: "", timeRange: [] };
      this.tradePage = 1;
      this.getTradeData();
    },
    // 委托数据
    async getOrderData() {
      let pageSizee = 1000;
      let startAt = new Date(this.orderForm.timeRange[0]).getTime();
      let endAt = new Date(this.orderForm.timeRange[1]).getTime();

      var orderTableArray = [];
      let tradeSymbol = [];
      if (this.tradeForm.pair === "") {
        for (let e of this.api.children) {
          var ddd = {
            symbol: e.symbol
          };
          tradeSymbol.push(ddd);
        }
      } else {
        var dddd = {
          symbol: this.tradeForm.pair
        };
        tradeSymbol.push(dddd);
      }

      // 如果交易对选了全部，有多个交易对就查多次
      for (let e of tradeSymbol) {
        var data = {
          uid: localStorage.getItem("userName"),
          apiId: this.token,
          exchange: Number(this.exchange),
          status: "",
          side: "",
          symbol: e.symbol,
          startAt: startAt,
          endAt: endAt,
          currentPage: this.orderPage.toString(),
          pageSize: pageSizee + ""
        };
        let res = await API.getOrders(data);
        if (res.data.errcode === 0) {
          var buffer = res.data.buffer;
          var message = exQryOrders.ExQryOrders.deserializeBinary(buffer);
          var orderData = message.getData();
          if (orderData.getCurrentpage > 0) {
            this.pageConfig.currentPage = orderData.getCurrentpage();
          }
          orderData.getItemsList().forEach((element) => {
            var orderInfo = {
              id: element.getId(),
              // intId: element.getIntid(),
              pair: element.getSymbol(),
              opType: element.getOptype(),
              // type: element.getType().toLowerCase(),
              direction: element.getSide().toLowerCase(),
              price: element.getPrice(),
              amount: element.getSize(),
              total: element.getFunds(),
              time:
                element.getCreatedat() === 0
                  ? ""
                  : utils.dateFormat(element.getCreatedat()),
              // cancelExist: element.getCancelexist(),
              // isActive: element.getIsactive(),
              // clientOid: element.getClientoid(),
              // iceberg: element.getIceberg(),
              visibleSize: element.getVisiblesize(),
              hidden: element.getHidden() === true ? "是" : "否",
              // postOnly: element.getPostonly(),
              // timeInForce: element.getTimeinforce(),
              // dealFunds: element.getDealfunds(),
              dealSize: element.getDealsize()
              // tradeType: element.getTradetype()
            };
            // 处理委托金额
            let fund = new Decimal(element.getPrice()).mul(new Decimal(element.getSize()));
            orderInfo.total = fund.toNumber();
            orderTableArray.push(orderInfo);
          });
        } else {
          this.$message.error(res.data.errcode + ":" + res.data.errmsg);
          if (res.data.errcode === 3005) {
            // 无效的登录凭证
            this.$router.push("/login");
          }
          if (res.data.errcode === 4004) {
            this.orderPage = this.orderPage - 1;
          }
        }
      }

      // 处理数据
      // console.log(orderTableArray);
      // 过滤买入卖出
      if (this.orderForm.direction) {
        orderTableArray = orderTableArray.filter((r) => {
          let row = r.direction;
          return row.includes(this.orderForm.direction);
        });
      }

      // console.log(orderTableArray);
      this.orderOriginData = orderTableArray;
      this.orderTableData = [];

      var orderLen = orderTableArray.length;
      this.orderTotal = orderLen;
      this.tableData = orderTableArray;
      let pageSize = this.orderPageSize;
      if (data.currentPage === "1") {
        if (orderLen > pageSize) {
          let start = (this.orderPage.toString() - 1) * pageSize;
          let end = this.orderPage.toString() * pageSize;
          this.orderTableData = orderTableArray.slice(start, end);
        } else {
          this.orderTableData = orderTableArray;
        }
      } else {
        this.orderTableData = orderTableArray;
      }
      this.getOrderDataTotal();
    },
    // 计算总计
    getOrderDataTotal() {
      this.orderTotalData = [];
      let totalAmount = new Decimal(0);
      let avgPrice = new Decimal(0);
      let totalTotal = new Decimal(0);
      let totalFDealSize = new Decimal(0);
      let orderLength = new Decimal(this.orderOriginData.length);
      for (let item of this.orderOriginData) {
        totalAmount = totalAmount.add(new Decimal(item.amount));
        avgPrice = avgPrice.add(new Decimal(item.price));
        totalTotal = totalTotal.add(new Decimal(item.total));
        totalFDealSize = totalFDealSize.add(new Decimal(item.dealSize));
      }
      let data = {
        amount: totalAmount.toNumber(),
        price: avgPrice.div(orderLength).toNumber().toFixed(6),
        total: totalTotal.toNumber(),
        dealSize: totalFDealSize.toNumber()
      };
      this.orderTotalData.push(data);
    },
    searchOrder() {
      this.orderPage = 1;
      this.getOrderData();
    },
    resetOrderForm() {
      this.orderForm = { id: "", pair: "", direction: "", type: "", timeRange: [] };
      this.orderPage = 1;
      this.getOrderData();
    },
    // 分页处理
    handleBalanceSizeChange(val) {
      this.balancePageSize = val;
      this.balancePage = 1;
      this.getBalanceData();
    },
    handleBalanceCurrentChange(val) {
      this.balancePage = val;
      this.getBalanceData();
    },
    handleTransferSizeChange(val) {
      this.transferPageSize = val;
      this.transferPage = 1;
      this.getTransferData();
    },
    handleTransferCurrentChange(val) {
      this.transferPage = val;
      this.getTransferData();
    },
    handleTradeSizeChange(val) {
      this.tradePageSize = val;
      this.tradePage = 1;
      this.getTradeData();
    },
    handleTradeCurrentChange(val) {
      let start = (val - 1) * this.tradePageSize;
      let end = val * this.tradePageSize;
      this.tradeData = this.tradeOriginData.slice(start, end);
      this.getTradeDataTotal();
    },
    handleOrderSizeChange(val) {
      this.orderPageSize = val;
      this.orderPage = 1;
      this.getOrderData();
    },
    handleOrderCurrentChange(val) {
      let start = (val - 1) * this.orderPageSize;
      let end = val * this.orderPageSize;
      this.orderTableData = this.orderOriginData.slice(start, end);
      this.getOrderDataTotal();
    },
    // 持仓
    async getPositionData() {
      let holdsDataArray = [];
      if (this.positionForm.pair === "") {
        for (let e of this.api.children) {
          var data = {
            uid: localStorage.getItem("userName"),
            apiId: this.token,
            exchange: Number(this.exchange),
            symbol: e.symbol
          };
          let res = await API.getHolds(data);
          if (res.data.errcode === 0) {
            var buffer = res.data.buffer;
            var message = exQryHolds.ExHolds.deserializeBinary(buffer);
            // console.log("message=", message);
            // console.log("message=", JSON.stringify(message));
            // let holdsData = message.getDataList();
            message.getDataList().forEach((element) => {
              var data = {
                symbol: element.getSymbol(),
                // holdId: element.getHoldid(),
                direction: element.getHoldside(),
                holdPrice: element.getHoldprice(),
                holdSz: element.getHoldsz(),
                openBal: element.getOpenbal(),
                // holdBal: element.getHoldbal(),
                // ccy: element.getCcy(),
                // cTime: element.getCtime(),
                // uTime: element.getUtime(),
                mgnMode: element.getMgnmode(),
                leverage: element.getLeverage(),
                liqPrice: element.getLiqprice()
              };
              // console.log(element.getLiqprice());
              if (this.exchange === 19) {
                // Bybit
                if (this.marginValue === "全仓") {
                  data.mgnMode = "cross";
                } else {
                  data.mgnMode = "isolated";
                }
              }
              // console.log(data)
              holdsDataArray.push(data);
            });
          } else {
            this.$message.error(res.data.errcode + ":" + res.data.errmsg);
            if (res.data.errcode === 3005) {
              // 无效的登录凭证
              this.$router.push("/login");
            }
            if (res.data.errcode === 4004) {
              this.pageConfig.currentPage = this.pageConfig.currentPage - 1;
            }
          }
        }
      } else {
        var data = {
          uid: localStorage.getItem("userName"),
          apiId: this.token,
          exchange: this.exchange,
          symbol: this.positionForm.pair
        };
        let res = API.getHolds(data);
        if (res.data.errcode === 0) {
          var buffer = res.data.buffer;
          var message = exQryHolds.ExHolds.deserializeBinary(buffer);
          // console.log("message=", message);
          // console.log("message=", JSON.stringify(message));
          
          // let holdsData = message.getDataList();
          message.getDataList().forEach((element) => {
            var data = {
              symbol: element.getSymbol(),
              // holdId: element.getHoldid(),
              direction: element.getHoldside(),
              holdPrice: element.getHoldprice(),
              holdSz: element.getHoldsz(),
              openBal: element.getOpenbal(),
              // holdBal: element.getHoldbal(),
              // ccy: element.getCcy(),
              // cTime: element.getCtime(),
              // uTime: element.getUtime(),
              mgnMode: element.getMgnmode(),
              leverage: element.getLeverage(),
              liqPrice: element.getLiqprice()
            };
            // console.log(element.getLiqprice());
            if (this.exchange === 19) {
              // Bybit
              if (this.marginValue === "全仓") {
                data.mgnMode = "cross";
              } else {
                data.mgnMode = "isolated";
              }
            }
            holdsDataArray.push(data);
          });
        } else {
          this.$message.error(res.data.errcode + ":" + res.data.errmsg);
          if (res.data.errcode === 3005) {
            // 无效的登录凭证
            this.$router.push("/login");
          }
          if (res.data.errcode === 4004) {
            this.pageConfig.currentPage = this.pageConfig.currentPage - 1;
          }
        }
      }
      // 处理数据
      if (this.positionForm.direction) {
        holdsDataArray = holdsDataArray.filter((r) => {
          let row = r.direction;
          return row.includes(this.positionForm.direction);
        });
      }
      this.positionData = holdsDataArray;
    },
    searchPosition() {
      this.positionCurrentPage = 1;
      this.getPositionData();
    },
    resetPositionForm() {
      this.positionForm = { pair: "", direction: "" };
      this.positionCurrentPage = 1;
      this.getPositionData();
    },
    handlePositionSizeChange(val) {
      this.positionPageSize = val;
      this.positionCurrentPage = 1;
      this.getPositionData();
    },
    handlePositionCurrentChange(val) {
      this.positionCurrentPage = val;
      this.getPositionData();
    },
    handleTransfer(row) {
      this.$message.success(`确认划转 ${row.amount} ${row.currency}`);
    },

    // ------------------导出excel---------------------------------------------------------------------------------------------
    // 成交记录导出
    exportTrade() {
      const workbook = XLSX.utils.book_new();
      const worksheet = {};

      // 先写总计的表
      worksheet['A1'] = { v: 'api' };
      worksheet['B1'] = { v: this.token };
      worksheet['A3'] = { v: '总成交数量' };
      worksheet['B3'] = { v: '平均成交价格' };
      worksheet['C3'] = { v: '总成交金额' };
      worksheet['D3'] = { v: '总手续费' };
      worksheet['A4'] = { v: this.tradeTotalData[0].amount };
      worksheet['B4'] = { v: this.tradeTotalData[0].price };
      worksheet['C4'] = { v: this.tradeTotalData[0].total };
      worksheet['D4'] = { v: this.tradeTotalData[0].fee };

      // 写入历史成交表
      worksheet['A6'] = { v: '成交编号' };
      worksheet['B6'] = { v: '成交时间' };
      worksheet['C6'] = { v: '交易对' };
      worksheet['D6'] = { v: '方向' };
      worksheet['E6'] = { v: '成交数量' };
      worksheet['F6'] = { v: '成交价格' };
      worksheet['G6'] = { v: '成交金额' };
      worksheet['H6'] = { v: '手续费' };
      worksheet['I6'] = { v: '计费币种' };

      for (let row = 0; row < this.tradeOriginData.length; row++) {
        worksheet[`A${row + 7}`] = { v: this.tradeOriginData[row].id };
        worksheet[`B${row + 7}`] = { v: this.tradeOriginData[row].time };
        worksheet[`C${row + 7}`] = { v: this.tradeOriginData[row].pair };
        worksheet[`D${row + 7}`] = { v: this.tradeOriginData[row].direction };
        worksheet[`E${row + 7}`] = { v: this.tradeOriginData[row].amount };
        worksheet[`F${row + 7}`] = { v: this.tradeOriginData[row].price };
        worksheet[`G${row + 7}`] = { v: this.tradeOriginData[row].total };
        worksheet[`H${row + 7}`] = { v: this.tradeOriginData[row].fee };
        worksheet[`I${row + 7}`] = { v: this.tradeOriginData[row].feeCurrency };
      }

      // 设置工作表的范围
      worksheet['!ref'] = `A1:I${this.tradeOriginData.length + 7}`;

      // 将工作表添加到工作簿
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
      
      // 导出文件
      const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
      const fileData = new Blob([excelBuffer], { type: 'application/octet-stream' });
      FileSaver.saveAs(fileData, `历史成交数据报表.xlsx`);
    },
    // 委托记录导出
    exportOrder() {
      const workbook = XLSX.utils.book_new();
      const worksheet = {};

      // 先写总计的表
      worksheet['A1'] = { v: 'api' };
      worksheet['B1'] = { v: this.token };
      worksheet['A3'] = { v: '总委托数量' };
      worksheet['B3'] = { v: '平均委托价格' };
      worksheet['C3'] = { v: '总委托金额' };
      worksheet['D3'] = { v: '总成交数量' };
      worksheet['A4'] = { v: this.orderTotalData[0].amount };
      worksheet['B4'] = { v: this.orderTotalData[0].price };
      worksheet['C4'] = { v: this.orderTotalData[0].total };
      worksheet['D4'] = { v: this.orderTotalData[0].dealSize };

      // 写入历史委托表
      worksheet['A6'] = { v: '委托编号' };
      worksheet['B6'] = { v: '委托时间' };
      worksheet['C6'] = { v: '交易对' };
      worksheet['D6'] = { v: '方向' };
      worksheet['E6'] = { v: '状态' };
      worksheet['F6'] = { v: '委托数量' };
      worksheet['G6'] = { v: '委托价格' };
      worksheet['H6'] = { v: '委托金额' };
      worksheet['I6'] = { v: '成交数量' };
      worksheet['J6'] = { v: '隐藏' };
      worksheet['K6'] = { v: '冰山单' };

      for (let row = 0; row < this.orderOriginData.length; row++) {
        worksheet[`A${row + 7}`] = { v: this.orderOriginData[row].id };
        worksheet[`B${row + 7}`] = { v: this.orderOriginData[row].time };
        worksheet[`C${row + 7}`] = { v: this.orderOriginData[row].pair };
        worksheet[`D${row + 7}`] = { v: this.orderOriginData[row].direction };
        worksheet[`E${row + 7}`] = { v: this.orderOriginData[row].opType };
        worksheet[`F${row + 7}`] = { v: this.orderOriginData[row].amount };
        worksheet[`G${row + 7}`] = { v: this.orderOriginData[row].price };
        worksheet[`H${row + 7}`] = { v: this.orderOriginData[row].total };
        worksheet[`I${row + 7}`] = { v: this.orderOriginData[row].dealSize };
        worksheet[`J${row + 7}`] = { v: this.orderOriginData[row].hidden };
        worksheet[`K${row + 7}`] = { v: this.orderOriginData[row].visibleSize };
      }

      // 设置工作表的范围
      worksheet['!ref'] = `A1:K${this.orderOriginData.length + 7}`;

      // 将工作表添加到工作簿
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
      
      // 导出文件
      const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
      const fileData = new Blob([excelBuffer], { type: 'application/octet-stream' });
      FileSaver.saveAs(fileData, `历史委托数据报表.xlsx`);
    }

  }
};
</script>

<style scoped>
.token-page {
  padding: 20px;
}

.tab-container {
  margin-top: 5px;
}

.tab-content {
  padding: 5px;
}

.search-form {
  margin-bottom: 10px;
  padding: 6px 10px;
  background-color: #f8f9fa;
  border-radius: 4px;
  /* border: 1px solid #700447; */
}

.search-form .el-form-item {
  margin-bottom: 6px;
}

.el-table {
  width: 100%;
}

.pagination {
  margin-top: 20px;
  text-align: right;
}
</style>